import { render, staticRenderFns } from "./MobileDataOverlay.vue?vue&type=template&id=2dc49cd5&scoped=true"
import script from "./MobileDataOverlay.vue?vue&type=script&lang=js"
export * from "./MobileDataOverlay.vue?vue&type=script&lang=js"
import style0 from "./MobileDataOverlay.vue?vue&type=style&index=0&id=2dc49cd5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc49cd5",
  null
  
)

export default component.exports